import Vue from 'vue';
import VProgressLinear from '../../components/VProgressLinear';
export default Vue.extend().extend({
    name: 'loadable',
    props: {
        loading: {
            type: [Boolean, String],
            default: false
        },
        loaderHeight: {
            type: [Number, String],
            default: 2
        }
    },
    methods: {
        genProgress() {
            if (this.loading === false)
                return null;
            return this.$slots.progress || this.$createElement(VProgressLinear, {
                props: {
                    absolute: true,
                    color: this.loading === true || this.loading === '' ? this.color || 'primary' : this.loading,
                    height: this.loaderHeight,
                    indeterminate: true
                }
            });
        }
    }
});
